import { AdvertiserOverallRatingResponse } from '@ha/api/v2/types/surveyReviews/AdvertiserOverallRating';
import { AdvertiserReportsResponse } from '@ha/api/v2/types/surveyReviews/AdvertiserReports';
import { User } from '@ha/api/v2/types/User';
import { UserInformation } from '@ha/api/v2/types/UserInformation';
import { ListingsGroup } from './types';

const ACTION_PREFIX = 'USER_PAGE';
export const STATE_NAME = 'userPage';

export const Actions = {
  LOAD_USER_START: `${ACTION_PREFIX}/LOAD_USER_START`,
  LOAD_USER_DONE: `${ACTION_PREFIX}/LOAD_USER_DONE`,
  LOAD_USER_FAIL: `${ACTION_PREFIX}/LOAD_USER_FAIL`,

  LOAD_TENANT_REVIEWS_OVERALL_START: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_START`,
  LOAD_TENANT_REVIEWS_OVERALL_DONE: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_DONE`,
  LOAD_TENANT_REVIEWS_OVERALL_FAIL: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_FAIL`,

  LOAD_TENANT_REVIEWS_REPORTS_START: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_START`,
  LOAD_TENANT_REVIEWS_REPORTS_DONE: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_DONE`,
  LOAD_TENANT_REVIEWS_REPORTS_FAIL: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_FAIL`,
};

export interface LoadUserDonePayload {
  type: string;
  payload: {
    user: User;
    userInfo: UserInformation;
  };
}

export interface LoadUserFailPayload {
  type: string;
  payload: {
    isNotFound: boolean;
    errors: object[];
  };
}

export interface LoadAdvertiserListingsDone {
  type: string;
  payload: ListingsGroup[];
}

export interface LoadKYCDone {
  type: string;
  payload: {
    isSpecificCountry: boolean;
  };
}

export interface LoadTenantReviewsDone {
  type: string;
  payload: {
    reports: AdvertiserReportsResponse;
    overallRating: AdvertiserOverallRatingResponse;
  };
}

export const LISTING_PREVIEW_IMAGE_HEIGHT = 210;

export const LISTINGS_PER_CITY_FILTER = 3;

export const MIN_SUMMARY_LENGTH = 3;
